import React from "react";
import { Search } from "lucide-react";
import { cn } from "@/lib/utils";

export function SearchBar({
  value,
  onChange,
  placeholder = "Search events, streams, cities…",
  className,
  testId = "search-bar",
}) {
  return (
    <div
      className={cn(
        "flex items-center gap-3 rounded-full border border-border bg-card px-5 py-3 shadow-sm transition-shadow focus-within:shadow-md",
        className
      )}
    >
      <Search className="h-5 w-5 shrink-0 text-muted-foreground" />
      <input
        data-testid={testId}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        className="w-full bg-transparent text-sm text-foreground outline-none placeholder:text-muted-foreground"
      />
    </div>
  );
}

export default SearchBar;
